import { StringMappingType } from 'typescript';

export default {
    oidc: {
        clientId: process.env.REACT_APP_CLIENT_ID as string,
    },
    // this section will change to azure functions
    userApi: {
        recoveryQuestions: process.env.REACT_APP_USR_API_GET_PWD as string,
        changeRecoveryQuestion: process.env.REACT_APP_USR_API_CHNG_QA as string,
        changePassword: process.env.REACT_APP_USR_API_CHNG_PWD as string,
        config: {
            baseUrl: process.env.REACT_APP_USR_API_BASE_URL,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        },
    },
    funtionUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL as string,
    functionUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL as string,
    maxFile: 25,
    searchApi: {
        stateUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'states',
        countyUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'counties',
        searchByUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'searchby',
        formatUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'formats',
        searchFieldListUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'searchFieldList',
        searchImageUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'files',
        deleteCacheUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'UserCacheDelete',
        printImageUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'PrintImage',
        saveImageUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'SaveImage',
        activityHistoryPostUrl:
            process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'UserActivityHistoryPost',
        activityHistoryGetUrl:
            process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'UserActivityHistoryGet',
        activityHistoryDeleteUrl:
            process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'UserActivityHistoryDelete',
        imageListGetUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'UserImageListGet',
        imageListPostUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'UserImageListPost',
        imageListDeleteUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'UserImageListDelete',
        imageUrlGetUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'ImageUrl',
        imageViewGet: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'ImageView',
        fileDetailsGetUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'fileDetails',
        fileDetailsTooltipGetUrl: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'fileDetailsTooltip',
        hierarchy: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'v2/hierarchy',
        hierarchySearch: process.env.REACT_APP_IMG_VWR_FUNC_BASEURL + 'v2/search',
    },
};
//senthil auth server

//https://dev-19632049.okta.com/oauth2/default
//0oawe3lgv66DibrhQ5d6

//raghavan auth server

//https://dev-12000580.okta.com/oauth2/default

//0oawelt2xVawtpjdB5d6
